export default __webpack_public_path__ + "static/media/Shipment.b958bcfb.svg";